import React from 'react';
import PropTypes from 'prop-types';
import { bemGenerator } from '@prisjakt/ui-base';

import './grid.scss';

const blockCount = 8;
const sizes = ['xs', 'sm', 'md', 'lg', 'xl'];
const combinations = [...Array(blockCount).keys()].reduce(
  (keys, n) => [...keys, ...sizes.map(size => `${size}${n + 1}`)],
  []
);

const styles = bemGenerator('pj-ui-grid', [...combinations, 'cell', 'row']);

class Grid extends React.Component {
  gridClasses() {
    return Object.keys(this.props.blocks).reduce(
      (classNames, key) => {
        const style = `${key}${this.props.blocks[key]}`;
        return `${classNames} ${styles[style]}`;
      },
      [
        styles.block.withModifier({
          'flex-mode': this.props.flexMode,
          'with-lines': this.props.withLines,
        }),
      ]
    );
  }

  static renderCell(child, index) {
    return (
      <div style={{ order: index + 1 }} className={styles.cell} key={child.key}>
        {child}
      </div>
    );
  }

  static renderRow(child, convertToRow) {
    const rowNumber = [convertToRow[child.props.id]];
    const mod = rowNumber ? { [rowNumber]: true } : {};

    return (
      <div className={styles.row.withModifier(mod)} key={child.key}>
        {child}
      </div>
    );
  }

  render() {
    const { children, convertToRow, className } = this.props;
    const isCell = child => !convertToRow[child.props.id];
    const isRow = child => !isCell(child);

    const [cells, rows] = [
      React.Children.toArray(children).filter(isCell),
      React.Children.toArray(children).filter(isRow),
    ];

    return (
      <div className={`${this.gridClasses()} ${className}`}>
        {rows.map(child => Grid.renderRow(child, convertToRow))}
        {cells.map((child, index) => Grid.renderCell(child, index))}
      </div>
    );
  }
}

const { number, node, shape, object, bool, string } = PropTypes;
Grid.propTypes = {
  children: node.isRequired,
  flexMode: bool,
  withLines: bool,
  convertToRow: object,
  className: string,
  blocks: shape({
    xs: number.isRequired,
    sm: number.isRequired,
    md: number.isRequired,
    lg: number.isRequired,
    xl: number.isRequired,
  }).isRequired,
};

Grid.defaultProps = {
  flexMode: false,
  withLines: false,
  convertToRow: {},
  className: '',
};

export default Grid;
